import { render, staticRenderFns } from "./ServiceAccountApiKeysList.vue?vue&type=template&id=b9412b36&scoped=true"
import script from "./ServiceAccountApiKeysList.vue?vue&type=script&lang=ts"
export * from "./ServiceAccountApiKeysList.vue?vue&type=script&lang=ts"
import style0 from "./ServiceAccountApiKeysList.vue?vue&type=style&index=0&id=b9412b36&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9412b36",
  null
  
)

export default component.exports